export default __webpack_public_path__ + "static/16614-910dcfa2e095f7155be2c1090980079e.jpg";